import React from "react";
import {connect} from "react-redux";
import List from '../../../components/CRM/List';
import ActionBar from "../../../components/CRM/ActionBar/";
import ActionMenu from "../../../components/CRM/ActionMenu";
import AdminsFilter from "./AdminsFilter";
import {
  Datagrid,
  TextField,
  refreshView as refreshViewAction
} from "admin-on-rest";
import { DateField } from "../../../components/CRM/DateField";


class AdminsDataListBase extends React.Component {
  state = {
    selectedRow: [],
    selectedAll: "",
    selectedIds: []
  };

  handleRowSelection = value => {
    if (Array.isArray(value)) {
      this.props.record.selectedRow = value;
    } else {
      this.props.record.selectedAll = value;
    }
    this.handleIdsSelection();
  };

  handleIdsSelection = () => {
    if (this.props.record.selectedAll === "none") {
      this.handleUnselectAll();
    } else {
      if (this.props.record.selectedAll === "all") {
        this.handleSelectAll();
      } else {
        if (
          this.props.record.selectedRow[0] ||
          this.props.record.selectedRow[0] === 0
        ) {
          this.handleSelectIds();
        } else {
          this.handleUnselectIds();
        }
      }
    }
  };

  handleUnselectAll = () => {
    this.props.record.ids = [];
    this.props.record.selectedAll = "";
    this.props.record.selectedRow = "";
    this.handleResetState();
    this.props.refreshView();
  };

  handleSelectAll = () => {
    this.props.record.ids = this.props.record.list.ids;
    this.props.record.selectedRow = [];
    this.props.record.selectedAll = "";
    this.handleResetState();
  };

  handleSelectIds = () => {
    this.props.record.list.ids.forEach((pair, index) => {
      this.props.record.selectedRow.forEach((value, key) => {
        if (value === index) {
          this.handleAddId(pair);
        }
        this.state.selectedIds.forEach((id, nb) => {
          if (id === pair) {
            if (!this.props.record.selectedRow.includes(index)) {
              this.handleRemoveId(id);
            }
          }
        });
      });
    });
  };

  handleAddId = pair => {
    if (this.state.selectedIds && !this.state.selectedIds.includes(pair)) {
      this.state.selectedIds.push(pair);
      this.props.record.ids = this.state.selectedIds;
    }
  };

  handleRemoveId = id => {
    function remove(array, element) {
      const index = array.indexOf(element);

      if (index !== -1) {
        array.splice(index, 1);
      }
    }
    remove(this.state.selectedIds, id);
    this.props.record.ids = this.state.selectedIds;
  };

  handleUnselectIds = () => {
    this.props.record.ids = [];
    this.props.record.selectedRow = [];
    this.handleResetState();
    this.props.refreshView();
  };

  handleResetState = () => {
    this.setState({
      selectedIds: [],
      selectedAll: "",
      selectedRow: []
    });
  };

  render() {
    const props = {...this.props};
    return (
      <List
        title="resources.admins.name"
        {...props}
        actions={<ActionBar {...props} />}
        filters={<AdminsFilter />}
      >
        <Datagrid
          options={{
            multiSelectable: true,
            selectable: true,
            onRowSelection: this.handleRowSelection
          }}
          headerOptions={{
            adjustForCheckbox: true,
            displaySelectAll: true,
            enableSelectAll: true
          }}
          bodyOptions={{
            displayRowCheckbox: true,
            deselectOnClickaway: false,
            showRowHover: true
          }}
          rowOptions={{
            selectable: true
          }}
        >
          <TextField
            label="resources.admins.fields.email"
            source="email"
          />

          <TextField
            label="resources.admins.fields.phoneNumber"
            source="phone"
          />

          <DateField
            label="resources.admins.fields.createdAt"
            source="created_at"
          />
          <DateField
            label="resources.admins.fields.updatedAt"
            source="updated_at"
          />

          <ActionMenu />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource]
  };
};

const AdminsDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(AdminsDataListBase);

export default AdminsDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/Admins/AdminsDataList.js